import React, { useState } from "react";

import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import { Button, FormControl, InputLabel, MenuItem, Checkbox, IconButton } from "@material-ui/core";
// import Checkbox from '@material-ui/Checkbox';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import { Grid, Card, Box, Select, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import { useEffect } from 'react';

import * as Yup from 'yup';
// styles
import useStyles from "./styles";
// components

import PageTitle from "../../components/PageTitle/PageTitle";

import SchooleRegistrationService from "./Locality/Service/schooleRegistration";
import AddClassService from "./Locality/Service/addClassService";
export default function SchooleRegistration(props) {
  const classes = useStyles();
  const [age, setAge] = React.useState('');
  var [error, setError] = useState(null);
  const [submitError, setSubmitError] = useState(null);
  const [otpDialogOpen, setOtpDialogOpen] = useState(false);
  const [otp, setOtp] = useState('');
  const [id, setId] = useState('');
  const [logoFile, setLogoFile] = useState(null);
  const [logoUrl, setLogoUrl] = useState('');
  const [uploadingLogo, setUploadingLogo] = useState(false);
  const [allClasses, setAllClasses] = useState([]);
  const [isClassesLoading, setIsClassesLoading] = useState(false);
  const [classesLoadError, setClassesLoadError] = useState(null);
  
  const [schooleRegistrationList, setSchooleRegistrationList] = useState([]);
  const [schooleRegistration, setSchooleRegistration] = useState({
    schooleName: '',
    societyName: '',
    branch: 'single',
    parentSchoolId: props.parentSchoolId || null,
    address: '',
    city: '',
    pincode: '',
    selectCountry: '',
    schoolType: '',
    name: '',
    email: '',
    mobileNumber: '',
    schooleEmail: '',
    schooleContact: '',
    password: '',
    subscription: '',
    terms: false,
    logo: '',
    classrooms: [],
  
  });

  const isBranchMode = !!props.parentSchoolId;
  const isEditMode = Boolean(props.editSchool?._id);
  const resolveSchoolId = (id) => (id && typeof id === 'object' ? id._id : id);
  const isChildSchoolEdit =
    isEditMode &&
    props.parentSchoolId &&
    String(resolveSchoolId(props.editSchool?._id)) !== String(props.parentSchoolId);
  const showBranchField = (!isBranchMode && !isEditMode) || (isEditMode && !isChildSchoolEdit);

  useEffect(() => {
    if (!props.editSchool?._id) return;
    const s = props.editSchool;
    const classroomIds = Array.isArray(s.classrooms)
      ? s.classrooms.map((c) => (c && typeof c === 'object' ? c._id : c)).filter(Boolean)
      : [];
    setSchooleRegistration({
      _id: s._id,
      schooleName: s.schooleName || '',
      societyName: s.societyName || '',
      branch: s.branch || 'single',
      parentSchoolId: s.parentSchoolId || props.parentSchoolId || null,
      address: s.address || '',
      city: s.city || '',
      pincode: s.pincode || '',
      selectCountry: s.selectCountry || '',
      schoolType: s.schoolType || '',
      name: s.name || '',
      email: s.email || '',
      mobileNumber: s.mobileNumber || '',
      schooleEmail: s.schooleEmail || '',
      schooleContact: s.schooleContact || '',
      password: '',
      subscription: s.subscription || 'yes',
      terms: true,
      logo: s.logo || '',
      classrooms: classroomIds,
      status: s.status,
    });
    setLogoUrl(s.logo || '');
  }, [props.editSchool, props.parentSchoolId]);

  useEffect(() => {
    let mounted = true;
    setIsClassesLoading(true);
    setClassesLoadError(null);
    AddClassService.getPublicAllClasses()
      .then((res) => {
        if (!mounted) return;
        setAllClasses(Array.isArray(res) ? res : []);
      })
      .catch((e) => {
        if (!mounted) return;
        setAllClasses([]);
        setClassesLoadError(e?.response?.data?.message || e?.message || "Unable to load classes");
      })
      .finally(() => {
        if (!mounted) return;
        setIsClassesLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const handleLogoFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file type
      if (!file.type.startsWith('image/')) {
        alert('Please select an image file');
        return;
      }
      // Validate file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        alert('Image size should be less than 5MB');
        return;
      }
      setLogoFile(file);
      
      // Create preview URL immediately
      const reader = new FileReader();
      reader.onloadend = () => {
        setLogoUrl(reader.result);
      };
      reader.readAsDataURL(file);

      // Auto-upload the logo
      setUploadingLogo(true);
      const formData = new FormData();
      formData.append('image', file);
      formData.append('imageName', file.name);

      try {
        const res = await SchooleRegistrationService.uploadImage(formData);
        setLogoUrl(res.url);
        setSchooleRegistration(prev => ({ ...prev, logo: res.url }));
        // Update formik values
        formik.setFieldValue('logo', res.url);
        setUploadingLogo(false);
      } catch (err) {
        console.error('Error uploading logo:', err);
        alert(err.response?.data?.message || 'Error uploading logo');
        setUploadingLogo(false);
        // Reset on error
        setLogoFile(null);
        setLogoUrl('');
        const fileInput = e.target;
        if (fileInput) {
          fileInput.value = '';
        }
      }
    }
  };

  const handleLogoRemove = () => {
    setLogoFile(null);
    setLogoUrl('');
    setSchooleRegistration(prev => ({ ...prev, logo: '' }));
    formik.setFieldValue('logo', '');
    // Reset file input
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = '';
    }
  };

  const validationSchema = Yup.object().shape({
    schooleName: Yup.string().required('schoole Name  is required'),
    societyName: Yup.string(),
    branch: Yup.string()
      .required('Branch is required')
      .oneOf(['single', 'multiple'], 'Branch is required'),
    parentSchoolId: Yup.string().nullable(),
    classrooms: Yup.array()
      .of(Yup.string())
      .min(1, 'Select at least one class')
      .required('Select at least one class'),
    address: Yup.string(),
    city: Yup.string().required('city is required'),
    pincode: Yup.string(),
    selectCountry: Yup.string().required('selectCountry is required'),
    schoolType: Yup.string()
      .required('Please select a school type')
      .oneOf(['indian', 'international', 'custom'], 'Please select Indian, International, or Custom'),
    name: Yup.string().required('name is required'),
    email: Yup.string(),
    mobileNumber: Yup.string().required()
      .matches(/^[0-9]+$/, "Must be only digits")
      .min(10, 'Must be exactly 10 digits')
      .max(10, 'Must be exactly 10 digits'),
    schooleEmail: Yup.string(),
    schooleContact: Yup.string(),
    password: isEditMode
      ? Yup.string()
      : Yup.string().required('password is required'),
    subscription: isEditMode
      ? Yup.string()
      : Yup.string()
          .required('Please select trial subscription option')
          .oneOf(['yes', 'no'], 'Please select either Yes or No for trial subscription'),
    terms: isEditMode
      ? Yup.boolean()
      : Yup.boolean()
          .required('You must agree to the Terms and Privacy Policy')
          .oneOf([true], 'You must agree to the Terms and Privacy Policy'),
  });
  const handleOtpSubmit = () => {
    const values = formik.values;
    // values.otpId=id
    // values.otp=otp
    SchooleRegistrationService.creteSchooleRegistration(values).then((res) => {
 
      alert(" Registration Successfully.");
      props.history.push('/montessori/login');
     
    })
   .catch((error) => {
    alert(error.message);
     console.error('Error generating OTP:', error);
   });
    // setOtpDialogOpen(false);
  };
  const getSchooleRegistrationList = () => {
    SchooleRegistrationService.getAllSchooleRegistration().then((res) => {
      setSchooleRegistrationList(res);
    }).catch((err) => {
      setError(err.message);
    });
  }

  const formik = useFormik({
    initialValues:  schooleRegistration,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {
      // Clear previous errors
      setSubmitError(null);
      
      // Include logo URL in submission
      const submitData = {
        ...values,
        logo: logoUrl || values.logo,
        // Convert terms boolean to string for backend
        terms: values.terms ? 'accepted' : ''
      };
      
      // Remove empty email field to avoid duplicate key error
      if (!submitData.email || submitData.email.trim() === '') {
        delete submitData.email;
      }

      if (isEditMode && values._id) {
        const updateData = { ...submitData };
        delete updateData.password;
        SchooleRegistrationService.updateSchooleRegistration(values._id, updateData)
          .then(() => {
            alert('School details updated successfully.');
            if (props.onSaved) {
              props.onSaved();
            } else if (props.onBack) {
              props.onBack();
            }
          })
          .catch((err) => {
            let errorMessage = 'Update failed. Please try again.';
            if (err.response?.data?.message) {
              errorMessage = err.response.data.message;
            } else if (err.message) {
              errorMessage = err.message;
            }
            setSubmitError(errorMessage);
          });
        return;
      }

      SchooleRegistrationService.creteSchooleRegistration(submitData).then((res) => {
        alert(" Registration Successfully.");
        props.history.push('/montessori/login');
      })
      
      // SchooleRegistrationService.otpGerate({mobile:values.mobileNumber})
      // .then((res) => {
      //   setId(res.id);
      //   setOtpDialogOpen(true);
      // })
   
        .catch((err) => {
          // Extract error message from response
          let errorMessage = 'Registration failed. Please try again.';
          
          if (err.response?.data?.message) {
            errorMessage = err.response.data.message;
          } else if (err.response?.data?.error) {
            errorMessage = err.response.data.error;
          } else if (err.message) {
            errorMessage = err.message;
          }
          
          // Handle MongoDB duplicate key error
          if (errorMessage.includes('E11000') || errorMessage.includes('duplicate key')) {
            if (errorMessage.includes('email')) {
              errorMessage = 'This email address is already registered. Please use a different email or leave it empty.';
            } else if (errorMessage.includes('mobileNumber')) {
              errorMessage = 'This mobile number is already registered. Please use a different mobile number.';
            } else {
              errorMessage = 'A record with this information already exists. Please check your details and try again.';
            }
          }
          
          setSubmitError(errorMessage);
        })
    },
  });

  return (

    <>
      <Card style={{ maxWidth: 1200, margin: '0 auto', padding: 16 }}>
        <Box>
          <div>
            {/* <form onSubmit={formik.handleSubmit} > */}
              <Grid container spacing={2} >
                {(isBranchMode || isEditMode) && (
                  <Grid item xs={12}>
                    <IconButton
                      onClick={() => {
                        if (props.onBack) {
                          props.onBack();
                        } else if (props.history && props.history.goBack) {
                          props.history.goBack();
                        } else {
                          window.history.back();
                        }
                      }}
                      style={{
                        backgroundColor: '#0f3b62',
                        color: '#fff',
                        marginBottom: 8,
                      }}
                    >
                      <ArrowBackIcon />
                    </IconButton>
                  </Grid>
                )}
                <Grid item xs={12}>
                  <PageTitle InputProps={{ style: { color: '#10b680' } }} title={isEditMode ? ' Edit School' : ' School Registration'} ></PageTitle>
                </Grid>
                {submitError && (
                  <Grid item xs={12}>
                    <div style={{
                      padding: '12px 16px',
                      backgroundColor: '#ffebee',
                      border: '1px solid #f44336',
                      borderRadius: '4px',
                      color: '#c62828',
                      marginTop: '10px',
                      marginBottom: '10px',
                      fontSize: '14px'
                    }}>
                      <strong>Error:</strong> {submitError}
                    </div>
                  </Grid>
                )}
                {(!isBranchMode || isEditMode) && (
                  <>
                    <Grid item xs={12} style={{ marginTop: '20px' }}>
                      <span style={{ fontSize: '20px', color: 'rgb(15 59 98)', fontWeight:"600" }}>School Logo:</span>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleLogoFileChange}
                        disabled={uploadingLogo}
                        style={{ marginBottom: '10px' }}
                      />
                      {uploadingLogo && (
                        <div style={{ marginTop: '10px', color: 'rgb(15 59 98)' }}>
                          Uploading logo...
                        </div>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      {logoUrl && (
                        <div style={{ marginTop: '10px', position: 'relative', display: 'inline-block' }}>
                          <img
                            src={logoUrl}
                            alt="School Logo Preview"
                            style={{
                              maxWidth: '200px',
                              maxHeight: '200px',
                              objectFit: 'contain',
                              border: '1px solid #ddd',
                              borderRadius: '4px',
                              padding: '5px'
                            }}
                          />
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={handleLogoRemove}
                            style={{
                              position: 'absolute',
                              top: '5px',
                              right: '5px',
                              minWidth: 'auto',
                              padding: '4px 8px',
                              backgroundColor: '#f44336',
                              color: 'white',
                              fontSize: '12px'
                            }}
                          >
                            Remove
                          </Button>
                        </div>
                      )}
                    </Grid>
                  </>
                )}
         
                <Grid item xs={12} sm={12} md={6}>
                  <TextField 
                    fullWidth
                    autoFocus
                    margin="dense"
                    id="schooleName"
                    name="schooleName"
                    label="Name Of The School"
                    required
                    type="text"
                    variant="outlined"
                    value={formik.values.schooleName}
                    onChange={formik.handleChange}
                    error={formik.touched.schooleName && Boolean(formik.errors.schooleName)}
                    helperText={formik.touched.schooleName && formik.errors.schooleName}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth
                    margin="dense"
                    id="societyName"
                    name="societyName"
                    label="Society Name"
                    type="text"
                    variant="outlined"
                    value={formik.values.societyName}
                    onChange={formik.handleChange}
                    error={formik.touched.societyName && Boolean(formik.errors.societyName)}
                    helperText={formik.touched.societyName && formik.errors.societyName}
                  />
                </Grid>
                {showBranchField && (
                  <Grid item xs={12} sm={12} md={6}>
                    <FormControl
                      fullWidth
                      margin="dense"
                      variant="outlined"
                      required
                      error={formik.touched.branch && Boolean(formik.errors.branch)}
                    >
                      <InputLabel id="branch-label">Branch</InputLabel>
                      <Select
                        labelId="branch-label"
                        id="branch"
                        name="branch"
                        label="Branch"
                        value={formik.values.branch}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      >
                        <MenuItem value="single">Single</MenuItem>
                        <MenuItem value="multiple">Multiple</MenuItem>
                      </Select>
                      {formik.touched.branch && formik.errors.branch && (
                        <FormHelperText>{formik.errors.branch}</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>
                )}

                {/* Classes (checkboxes) */}
                <Grid item xs={12} style={{ marginTop: 14 }}>
                  <span style={{ fontSize: '20px', color: 'rgb(15 59 98)', fontWeight:"600" }}>
                    Select Classes:<span style={{ color: "#f44336" }}> *</span>
                  </span>
                </Grid>
                <Grid item xs={12}>
                  {isClassesLoading ? (
                    <span style={{ fontSize: 13, color: "#6b7280" }}>Loading classes...</span>
                  ) : classesLoadError ? (
                    <span style={{ fontSize: 13, color: "#b91c1c" }}>{classesLoadError}</span>
                  ) : allClasses.length === 0 ? (
                    <span style={{ fontSize: 13, color: "#6b7280" }}>No classes found</span>
                  ) : (
                    <Grid container spacing={1}>
                      {allClasses.map((c) => {
                        const classId = c?._id || c?.id || c?.classId;
                        const className = c?.className || c?.name || "";
                        if (!classId || !className) return null;
                        const checked = (formik.values.classrooms || []).includes(classId);
                        return (
                          <Grid item xs={12} sm={6} md={4} key={classId}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  color="primary"
                                  checked={checked}
                                  onChange={(e) => {
                                    const next = new Set(formik.values.classrooms || []);
                                    if (e.target.checked) next.add(classId);
                                    else next.delete(classId);
                                    formik.setFieldValue("classrooms", Array.from(next));
                                  }}
                                />
                              }
                              label={className}
                            />
                          </Grid>
                        );
                      })}
                    </Grid>
                  )}
                  {!!(formik.touched.classrooms && formik.errors.classrooms) && (
                    <FormHelperText error>{formik.errors.classrooms}</FormHelperText>
                  )}
                </Grid>
                <Grid item xs={12} style={{ marginTop: '30px' }}>
                  <span style={{ fontSize: '20px', color: 'rgb(15 59 98)', fontWeight:"600" }} >Address:</span>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    margin="dense"
                    id="address"
                    name="address"
                    placeholder="Street, Area / Landmark"
                    label="Address"
                    type="text"
                    variant="outlined"
                    multiline
                    rows={3}
                    value={formik.values.address}
                    onChange={formik.handleChange}
                    error={formik.touched.address && Boolean(formik.errors.address)}
                    helperText={formik.touched.address && formik.errors.address}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth           
                    margin="dense"
                    id="city"
                    name="city"
                    label="City "
                    required
                    type="text"
                    variant="outlined"
                    value={formik.values.city}
                    
                    onChange={formik.handleChange}
                    error={formik.touched.city && Boolean(formik.errors.city)}
                    helperText={formik.touched.city && formik.errors.city}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth
                    margin="dense"
                    id="pincode"
                    name="pincode"
                    label="Pin Code"
                    type="text"
                    variant="outlined"
                    value={formik.values.pincode}
                    
                    onChange={formik.handleChange}
                    error={formik.touched.pincode && Boolean(formik.errors.pincode)}
                    helperText={formik.touched.pincode && formik.errors.pincode}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} >
                  <FormControl fullWidth margin="dense" variant="outlined" required>
                    <InputLabel id="demo-simple-select-label">Select country</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="selectCountry"
                      name="selectCountry"

                      label="Select country"
                      onChange={formik.handleChange}
                      value={formik.values.selectCountry}
                      error={formik.touched.selectCountry && Boolean(formik.errors.selectCountry)}
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      <MenuItem value={1}>United States</MenuItem>
                      <MenuItem value={2}>United Kingdom</MenuItem>
                      <MenuItem value={3}>Australia</MenuItem>
                      <MenuItem value={4}>India</MenuItem>
                      <MenuItem value={5}>Finland</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <FormControl
                    component="fieldset"
                    error={formik.touched.schoolType && Boolean(formik.errors.schoolType)}
                    fullWidth
                    required
                  >
                    <FormLabel component="legend">Select Type</FormLabel>
                    <RadioGroup
                      row
                      aria-label="schoolType"
                      name="schoolType"
                      id="schoolType"
                      value={formik.values.schoolType}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      <FormControlLabel value="indian" control={<Radio />} label="Indian" />
                      <FormControlLabel value="international" control={<Radio />} label="International" />
                      <FormControlLabel value="custom" control={<Radio />} label="Custom" />
                    </RadioGroup>
                    {formik.touched.schoolType && formik.errors.schoolType && (
                      <FormHelperText style={{ color: '#f44336', marginLeft: 14 }}>
                        {formik.errors.schoolType}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12} style={{ marginTop: '30px' }}>
                  <span style={{ fontSize: '20px', color: 'rgb(15 59 98)', fontWeight:"600" }} >Contact Details:</span>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>

                  <TextField
                    fullWidth
                    
                    margin="dense"
                    id="name"
                    name="name"
                    label="Full Name"
                    required
                    type="Full Name"
                    variant="outlined"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    error={formik.touched.name && Boolean(formik.errors.name)}
                    helperText={formik.touched.name && formik.errors.name}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>

                  <TextField
                    fullWidth
                    margin="dense"
                    id="email"
                    name="email"
                    label="Email ID"
                    type="Email ID"
                    variant="outlined"
                    autoComplete="off"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth
                    margin="dense"
                    id="mobileNumber"
                    name="mobileNumber"
                    label="Mobile Number (login)"
                    required
                    type="Mobile Number"
                    variant="outlined"
                    autoComplete="off"
                    value={formik.values.mobileNumber}
                    onChange={formik.handleChange}
                    error={formik.touched.mobileNumber && Boolean(formik.errors.mobileNumber)}
                    helperText={formik.touched.mobileNumber && formik.errors.mobileNumber}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>

                  <TextField
                    fullWidth
                    
                    margin="dense"
                    id="schooleEmail"
                    name="schooleEmail"
                    label="School Email "
                    type="Schoole Email"
                    variant="outlined"
                    value={formik.values.schooleEmail}
                    onChange={formik.handleChange}
                    error={formik.touched.schooleEmail && Boolean(formik.errors.schooleEmail)}
                    helperText={formik.touched.schooleEmail && formik.errors.schooleEmail}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>

                  <TextField
                    fullWidth
                    
                    margin="dense"
                    id="schooleContact  "
                    name="schooleContact"
                    label="School contact number   "
                    type="Schoole contact number "
                    variant="outlined"
                    value={formik.values.schooleContact}

                    onChange={formik.handleChange}
                    error={formik.touched.schooleContact && Boolean(formik.errors.schooleContact)}
                    helperText={formik.touched.schooleContact && formik.errors.schooleContact}
                  />
                </Grid>

                {!isEditMode && (
                <Grid item xs={12} sm={12} md={6}>

                  <TextField
                    id="password"
                    fullWidth
                    margin="normal"
                    label=" Set Password  "
                    required
                    variant="outlined"
                    type="password"
                    name="password"
                    autoComplete="off"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    error={formik.touched.password && Boolean(formik.errors.password)}
                    helperText={formik.touched.password && formik.errors.password}
                  />
                </Grid>
                )}
                {!isEditMode && (
                <>
                {/* Trial subscription: show for both main and branch registration */}
                <Grid item xs={12} sm={12} md={6}>
                  <FormControl 
                    component="fieldset" 
                    error={formik.touched.subscription && Boolean(formik.errors.subscription)}
                    fullWidth
                    required
                  >
                    <FormLabel component="legend">Avail trial subscription</FormLabel>
                    <RadioGroup 
                      aria-label="subscription"
                      name="subscription" 
                      id="subscription" 
                      value={formik.values.subscription}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                      <FormControlLabel value="no" control={<Radio />} label="No" />
                    </RadioGroup>
                    {formik.touched.subscription && formik.errors.subscription && (
                      <FormHelperText style={{ color: '#f44336', marginLeft: 14 }}>
                        {formik.errors.subscription}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <FormControl 
                    error={formik.touched.terms && Boolean(formik.errors.terms)}
                    fullWidth
                    required
                  >
                    <FormControlLabel
                      control={
                        <Checkbox   
                          name="terms"  
                          id="terms" 
                          checked={formik.values.terms}
                          onChange={(e) => formik.setFieldValue('terms', e.target.checked)}
                          color="primary"
                        />
                      }
                      label={
                        <span style={{ color: '#5f6368' }}>
                          By continuing you agree to our 
                          <a href="https://www.montestory.in/#/montessori/term" target="_blank" rel="noopener noreferrer" style={{ color: '#6c63ff', textDecoration: 'underline', marginLeft: 4, marginRight: 4 }}>Terms</a>
                          and
                          <a href="https://www.montestory.in/#/montessori/privacy" target="_blank" rel="noopener noreferrer" style={{ color: '#6c63ff', textDecoration: 'underline', marginLeft: 4 }}>Privacy Policy</a>.
                        </span>
                      }
                    />
                    {formik.touched.terms && formik.errors.terms && (
                      <FormHelperText style={{ color: '#f44336', marginLeft: 14 }}>
                        {formik.errors.terms}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                </>
                )}
            
              </Grid>
              <div style={{ textAlign: 'right', margin: '29px' }}>
                <Button style={{ backgroundColor: 'rgb(15 59 98)', color: 'white' }}
                onClick={ formik.handleSubmit} type="submit" variant="contained" >{isEditMode ? 'Update School' : 'Submit'}</Button>
              </div>
              {/* <Dialog open={otpDialogOpen} onClose={() => setOtpDialogOpen(false)}>
        <DialogTitle>Enter OTP</DialogTitle>
        <DialogContent>
          <TextField
            label="OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            fullWidth
            margin="dense"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOtpDialogOpen(false)} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleOtpSubmit} color="primary">
            Submit
          </Button>
        </DialogActions>
      </Dialog> */}

            {/* </form> */}
          </div>
        </Box>

      </Card>

    </>
  );
}

